import { ActionTypes } from "~/types/common";
import assign from "lodash/assign";
import { SetSessionSummaryAction, ClearSessionSummaryAction } from "~/types/session-summary";
import { ReduxState } from "~/types/redux";
type SessionSummaryActions = SetSessionSummaryAction | ClearSessionSummaryAction;
const sessionSummary = (state: ReduxState, action: SessionSummaryActions): ReduxState => {
  switch (action.type) {
    case ActionTypes.SET_SESSION_SUMMARY:
      return assign({}, state, {
        sessionSummary: {
          ...state.sessionSummary,
          ...action.data
        }
      });
    case ActionTypes.CLEAR_SESSION_SUMMARY:
      return assign({}, state, {
        sessionSummary: undefined
      });
    default:
      return state;
  }
};
export default sessionSummary;